//most-frequent non-irregular verbs, to be conjugated for the lexicon
//this list is the seed, from which various forms are conjugated
module.exports = [
  "collapse",
  "stake",
  "forsee",
  "suck",
  "answer",
  "argue",
  "tend",
  "examine",
  "depend",
  "form",
  "figure",
  "mind",
  "surround",
  "suspect",
  "reflect",
  "wonder",
  "hope",
  "end",
  "thank",
  "file",
  "regard",
  "report",
  "imagine",
  "consider",
  "ensure",
  "cause",
  "work",
  "enter",
  "stop",
  "defeat",
  "surge",
  "launch",
  "turn",
  "like",
  "control",
  "relate",
  "remember",
  "join",
  "listen",
  "train",
  "spring",
  "enjoy",
  "fail",
  "recognize",
  "obtain",
  "learn",
  "fill",
  "announce",
  "prevent",
  "achieve",
  "realize",
  "involve",
  "remove",
  "aid",
  "visit",
  "test",
  "prepare",
  "ask",
  "carry",
  "suppose",
  "determine",
  "raise",
  "love",
  "use",
  "pull",
  "improve",
  "contain",
  "offer",
  "talk",
  "pick",
  "care",
  "express",
  "remain",
  "operate",
  "close",
  "add",
  "mention",
  "support",
  "decide",
  "walk",
  "vary",
  "demand",
  "describe",
  "agree",
  "happen",
  "allow",
  "suffer",
  "study",
  "press",
  "watch",
  "seem",
  "occur",
  "contribute",
  "claim",
  "compare",
  "apply",
  "direct",
  "discuss",
  "indicate",
  "require",
  "change",
  "fix",
  "reach",
  "prove",
  "expect",
  "exist",
  "play",
  "permit",
  "kill",
  "charge",
  "increase",
  "believe",
  "create",
  "continue",
  "live",
  "help",
  "represent",
  "edit",
  "serve",
  "appear",
  "cover",
  "maintain",
  "start",
  "stay",
  "move",
  "extend",
  "design",
  "supply",
  "suggest",
  "want",
  "approach",
  "call",
  "include",
  "try",
  "receive",
  "save",
  "discover",
  "marry",
  "need",
  "establish",
  "keep",
  "assume",
  "attend",
  "unite",
  "explain",
  "publish",
  "accept",
  "settle",
  "reduce",
  "do",
  "look",
  "interact",
  "concern",
  "labor",
  "return",
  "select",
  "die",
  "provide",
  "seek",
  "wish",
  "finish",
  "follow",
  "disagree",
  "produce",
  "attack",
  "attempt",
  "brake",
  "brush",
  "burn",
  "bang",
  "bomb",
  "budget",
  "comfort",
  "cook",
  "copy",
  "cough",
  "crush",
  "cry",
  "check",
  "claw",
  "clip",
  "combine",
  "damage",
  "desire",
  "doubt",
  "drain",
  "dance",
  "decrease",
  "defect",
  "deposit",
  "drift",
  "dip",
  "dive",
  "divorce",
  "dream",
  "exchange",
  "envy",
  "exert",
  "exercise",
  "export",
  "fold",
  "flood",
  "focus",
  "forecast",
  "fracture",
  "grip",
  "guide",
  "guard",
  "guarantee",
  "guess",
  "hate",
  "heat",
  "handle",
  "hire",
  "host",
  "hunt",
  "hurry",
  "import",
  "judge",
  "jump",
  "jam",
  "kick",
  "kiss",
  "knock",
  "laugh",
  "lift",
  "lock",
  "lecture",
  "link",
  "load",
  "loan",
  "lump",
  "melt",
  "message",
  "murder",
  "neglect",
  "overlap",
  "overtake",
  "overuse",
  "print",
  "protest",
  "pump",
  "push",
  "post",
  "progress",
  "promise",
  "purchase",
  "regret",
  "request",
  "reward",
  "roll",
  "rub",
  "rent",
  "repair",
  "sail",
  "scale",
  "screw",
  "shock",
  "sleep",
  "slip",
  "smash",
  "smell",
  "smoke",
  "sneeze",
  "snow",
  "surprise",
  "scratch",
  "search",
  "share",
  "shave",
  "spit",
  "splash",
  "stain",
  "stress",
  "switch",
  "taste",
  "touch",
  "trade",
  "trick",
  "twist",
  "trap",
  "travel",
  "tune",
  "undergo",
  "undo",
  "uplift",
  "vote",
  "wash",
  "wave",
  "whistle",
  "wreck",
  "yawn",
  "betray",
  "restrict",
  "perform",
  "worry",
  "point",
  "activate",
  "fear",
  "plan",
  "note",
  "face",
  "predict",
  "differ",
  "deserve",
  "torture",
  "recall",
  "count",
  "admit",
  "insist",
  "lack",
  "pass",
  "belong",
  "complain",
  "constitute",
  "rely",
  "refuse",
  "range",
  "cite",
  "flash",
  "arrive",
  "reveal",
  "consist",
  "observe",
  "notice",
  "trust",
  "display",
  "view",
  "stare",
  "acknowledge",
  "owe",
  "gaze",
  "treat",
  "account",
  "gather",
  "address",
  "confirm",
  "estimate",
  "manage",
  "participate",
  "sneak",
  "drop",
  "mirror",
  "experience",
  "strive",
  "arch",
  "dislike",
  "favor",
  "earn",
  "emphasize",
  "match",
  "question",
  "emerge",
  "encourage",
  "matter",
  "name",
  "head",
  "line",
  "slam",
  "list",
  "warn",
  "ignore",
  "resemble",
  "feature",
  "place",
  "reverse",
  "accuse",
  "spoil",
  "retain",
  "survive",
  "praise",
  "function",
  "please",
  "date",
  "remind",
  "deliver",
  "echo",
  "engage",
  "deny",
  "yield",
  "center",
  "gain",
  "anticipate",
  "reason",
  "side",
  "thrive",
  "defy",
  "dodge",
  "enable",
  "applaud",
  "bear",
  "persist",
  "pose",
  "reject",
  "attract",
  "await",
  "inhibit",
  "declare",
  "process",
  "risk",
  "urge",
  "value",
  "block",
  "confront",
  "credit",
  "cross",
  "amuse",
  "dare",
  "resent",
  "smile",
  "gloss",
  "threaten",
  "collect",
  "depict",
  "dismiss",
  "submit",
  "benefit",
  "step",
  "deem",
  "limit",
  "sense",
  "issue",
  "embody",
  "force",
  "govern",
  "replace",
  "bother",
  "cater",
  "adopt",
  "empower",
  "outweigh",
  "alter",
  "enrich",
  "influence",
  "prohibit",
  "pursue",
  "warrant",
  "convey",
  "approve",
  "reserve",
  "rest",
  "strain",
  "wander",
  "adjust",
  "dress",
  "market",
  "mingle",
  "disapprove",
  "evaluate",
  "flow",
  "inhabit",
  "pop",
  "rule",
  "depart",
  "roam",
  "assert",
  "disappear",
  "envision",
  "pause",
  "afford",
  "challenge",
  "grab",
  "grumble",
  "house",
  "portray",
  "revel",
  "base",
  "conduct",
  "review",
  "stem",
  "crave",
  "mark",
  "store",
  "target",
  "unlock",
  "weigh",
  "resist",
  "drag",
  "pour",
  "reckon",
  "assign",
  "cling",
  "rank",
  "attach",
  "decline",
  "destroy",
  "interfere",
  "paint",
  "skip",
  "sprinkle",
  "wither",
  "allege",
  "retire",
  "score",
  "monitor",
  "expand",
  "honor",
  "pack",
  "assist",
  "float",
  "appeal",
  "stretch",
  "undermine",
  "assemble",
  "boast",
  "bounce",
  "grasp",
  "install",
  "borrow",
  "crack",
  "elect",
  "shout",
  "contrast",
  "overcome",
  "relax",
  "relent",
  "strengthen",
  "conform",
  "dump",
  "pile",
  "scare",
  "relive",
  "resort",
  "rush",
  "boost",
  "cease",
  "command",
  "excel",
  "plug",
  "plunge",
  "proclaim",
  "discourage",
  "endure",
  "ruin",
  "stumble",
  "abandon",
  "cheat",
  "convince",
  "merge",
  "convert",
  "harm",
  "multiply",
  "overwhelm",
  "chew",
  "invent",
  "bury",
  "wipe",
  "added",
  "took",
  "define",
  "goes",
  "measure",
  "enhance",
  "distinguish",
  "avoid",
  //contractions
  "don't",
  "won't",
  "what's" //somewhat ambiguous (what does|what are)

]



//////////////////
// WEBPACK FOOTER
// ./~/nlp_compromise/src/data/lexicon/verbs.js
// module id = 296
// module chunks = 0